import { isWeiXin, isNotEmpty, _isMobile } from "@/libs/tools";
import { Component, Vue } from "vue-property-decorator";
import { Mutation } from "vuex-class";
import { isLogin, logout } from "@/libs/auth";

@Component
export default class IndexHeader extends Vue {
    private isLogin: boolean = false;
    private userImg: string = "";
    private currentRouter: string = "home";
    private menuFlag: boolean = false;
    private currentOrigin: string = "";
    @Mutation("login/changeLoginStatus")
    mutationChangeLoginStatus: any;
    get wx(): boolean {
        return isWeiXin();
    }

    private user = {
        userId: "",
        needSetPhone: false,
        needBindWeChat: false
    };

    private showBindTel: boolean = false;
    private bindType: string = "tel";

    static isLogin(): boolean {
        const refreshToken = localStorage.getItem("refreshToken") || "";
        return isNotEmpty(refreshToken);
    }

    mounted(): void {
        this.currentOrigin = window.origin;
        // if (this.$route.name === "Home") {
        //     this.currentRouter = "home";
        // } else if (this.$route.name === "Courses") {
        //     this.currentRouter = "courses";
        // } else if (this.$route.name === "MyRoom") {
        //     this.currentRouter = "myRoom";
        // } else if (this.$route.name === "Cooperation") {
        //     this.currentRouter = "cooperation";
        // } else if (this.$route.name === "AboutUs") {
        //     this.currentRouter = "aboutUs";
        // } else if (this.$route.name === "Teacher") {
        //     this.currentRouter = "teacher";
        // } else if (this.$route.name === "Achieve") {
        //     this.currentRouter = "achieve";
        // } else if (this.$route.name === "OpenClass") {
        //     this.currentRouter = "ocou";
        // } else if (this.$route.name === "NewsCenter") {
        //     this.currentRouter = "news";
        // }
        this.isLogin = isLogin();
        if (this.isLogin) {
            this.userImg = JSON.parse(
                <string>localStorage.getItem("user")
            ).avatar;
            if (!this.userImg) {
                this.userImg =
                    "https://asset.greedyai.com/sun/img/defaultAvatar.png";
            }
        }

        //new add
        if (isNotEmpty(<any>localStorage.getItem("user"))) {
            this.user = JSON.parse(<any>localStorage.getItem("user"));
            this.$store.state.bind.bind.userId = this.user.userId;
            if (this.user.needSetPhone || this.user.needBindWeChat) {
                this.showBindTel = true;
                this.bindType = this.user.needSetPhone ? "tel" : "wx";
                this.$store.state.bind.bind.bindType = this.bindType;
                this.$store.state.bind.bind.showBindTel = this.showBindTel;
            }
        }
    }

    loginClick(val: string) {
        // 微信内打开直接调用服务号登录
        if (isWeiXin()) {
            window.location.href = location.origin + "/fwhLogin";
        } else {
            this.$router.push("/login?status=" + val);
        }
    }

    signOutClick() {
        logout();
    }
    handleCommand(command) {
        if (command === "logout") {
            logout();
        } else {
            this.$router.push("/" + command);
        }
    }
    handleTabClick(val: string) {
        if (val === "employment") {
            this.$router.push("/" + val + "/60");
        } else if (val === "research") {
            window.open("https://research.greedyai.com/");
        } else if (val === "home") {
            this.currentRouter = val;
            this.$router.push("/");
        } else {
            this.currentRouter = val;
            this.$router.push("/" + val);
        }
    }
    handleOpenClick() {
        this.menuFlag = true;
    }
    handleCloseClick() {
        this.menuFlag = false;
    }
}
//@ts-ignore
export { default as IndexHeader } from "./index.vue";
